import { render } from "./GenogramKidsTemplateDialog.vue?vue&type=template&id=7042d706"
import script from "./GenogramKidsTemplateDialog.vue?vue&type=script&lang=js"
export * from "./GenogramKidsTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__